export const bgVariants = {
  accentPrimary10: 'bg-accentPrimary10',
  accentPrimary20: 'bg-accentPrimary20',
  accentPrimary30: 'bg-accentPrimary30',
  accentPrimary40: 'bg-accentPrimary40',
  accentPrimary50: 'bg-accentPrimary50',
  accentSecondary10: 'bg-accentSecondary10',
  accentSecondary20: 'bg-accentSecondary20',
  accentSecondary30: 'bg-accentSecondary30',
  accentSecondary40: 'bg-accentSecondary40',
  neutral10: 'bg-neutral10',
  neutral20: 'bg-neutral20',
  neutral30: 'bg-neutral30',
  neutral40: 'bg-neutral40',
  neutral50: 'bg-neutral50',
  systemDisabled10: 'bg-systemDisabled10',
  systemDisabled20: 'bg-systemDisabled20',
  systemError10: 'bg-systemError10',
  systemError20: 'bg-systemError20',
  systemInfo10: 'bg-systemInfo10',
  systemInfo20: 'bg-systemInfo20',
  systemSuccess10: 'bg-systemSuccess10',
  systemSuccess20: 'bg-systemSuccess20',
  systemWarning10: 'bg-systemWarning10',
  systemWarning20: 'bg-systemWarning20',
  overlay: 'bg-overlay',
};

export const textColorVariants = {
  neutral10: 'text-neutral10',
  neutral20: 'text-neutral20',
  neutral30: 'text-neutral30',
  accentPrimary10: 'text-accentPrimary10',
  accentPrimary20: 'text-accentPrimary20',
  accentSecondary10: 'text-accentSecondary10',
  systemError: 'text-systemError',
  systemSuccess: 'text-systemSuccess',
  systemInfo: 'text-systemInfo',
  systemWarning: 'text-systemWarning',
};

export const gapVariants = {
  '2xs': 'gap-2xs',
  xs: 'gap-xs',
  sm: 'gap-sm',
  md: 'gap-md',
  lg: 'gap-lg',
  xl: 'gap-xl',
  '2xl': 'gap-2xl',
  page: 'gap-page',
  section: 'gap-section',
  container: 'gap-container',
  form: 'gap-form',
  'sibling-card': 'gap-sibling-card',
};

export const rowGapVariants = {
  '2xs': 'gap-x-2xs',
  xs: 'gap-x-xs',
  sm: 'gap-x-sm',
  md: 'gap-x-md',
  lg: 'gap-x-lg',
  xl: 'gap-x-xl',
  '2xl': 'gap-x-2xl',
  page: 'gap-x-page',
  section: 'gap-x-section',
  container: 'gap-x-container',
  form: 'gap-x-form',
  'sibling-card': 'gap-x-sibling-card',
};

export const columnGapVariants = {
  '2xs': 'gap-y-2xs',
  xs: 'gap-y-xs',
  sm: 'gap-y-sm',
  md: 'gap-y-md',
  lg: 'gap-y-lg',
  xl: 'gap-y-xl',
  '2xl': 'gap-y-2xl',
  page: 'gap-y-page',
  section: 'gap-y-section',
  container: 'gap-y-container',
  form: 'gap-y-form',
  'sibling-card': 'gap-y-sibling-card',
};

export type TGap = keyof typeof gapVariants;

export const alignItemsVariants = {
  start: 'items-start',
  center: 'items-center',
  end: 'items-end',
  stretch: 'items-stretch',
  baseline: 'items-baseline',
};

export const justifyContentVariants = {
  start: 'justify-start',
  center: 'justify-center',
  end: 'justify-end',
  between: 'justify-between',
  around: 'justify-around',
};
